import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { BrowserRouter, Route } from 'react-router-dom'
import { QueryParamProvider } from 'use-query-params'
import { useGlobalRoutes } from './routes/globalRoutes'
import { msalInstance } from './azure/azureConfig'
import { getUserState } from './redux/userSlice'

import "react-datepicker/dist/react-datepicker.css"

function App() {
  const dispatch = useDispatch()
  const routes = useGlobalRoutes()

  useEffect(() => {
    // no interactive call here - a popup outside a user gesture is blocked by the browser
    msalInstance.handleRedirectPromise()
    .then((response) => {
      if (response) {
        localStorage.setItem('userRole', response?.idTokenClaims?.roles?.[0])
      }
      if (msalInstance.getAllAccounts().length) {
        dispatch(getUserState())
      }
    })
    .catch((e) => {
      console.error(e);
    })
  }, [dispatch])

  return (
    <BrowserRouter>
      <QueryParamProvider ReactRouterRoute={Route}>
        {routes}
      </QueryParamProvider>
    </BrowserRouter>
  )
}

export default App;
